/**
 * Reusable constants for Project Management domain.
 */

export const PROJECT_TYPE_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'parent', label: 'Parent projects' },
  { value: 'subproject', label: 'SubProject' },
]
